import { theme } from '../../constants/defaults';

export default class HideAndSeek {
  constructor() {
    this.itemsToFindElSelector = '.js-hide-and-seek-item';
    const itemsToFindEls = document.querySelectorAll(this.itemsToFindElSelector);
    // Attention, these keys have to be the same as the one of the html items on the site!
    this.itemsToFindKeys = ['egg-1', 'egg-2', 'egg-3'];
    // This discount code has to be created in the Shopify admin
    this.discountCode = 'MCEASTER2022';
    this.hideAndSeekModalNamespace = 'hide-and-seek-modal';
    this.hideAndSeekModal = document.getElementById(this.hideAndSeekModalNamespace);
    this.hideAndSeekBasket = document.querySelector('.hide-and-seek-basket');
    this.hideAndSeekBasketItemsCountEl = this.hideAndSeekBasket.querySelector(
      '.js-hide-and-seek-basket-items-count',
    );
    this.hideAndSeekBasketCountEl = this.hideAndSeekBasket.querySelector(
      '.js-hide-and-seek-basket-count',
    );
    this.hideAndSeekBasketTotalEl = this.hideAndSeekBasket.querySelector(
      '.js-hide-and-seek-basket-total',
    );
    this.hideAndSeekBasketCompletedEl = this.hideAndSeekBasket.querySelector(
      '.js-hide-and-seek-basket-complete',
    );
    this.foundClass = 'hide-and-seek-basket__item--found';
    // this.hideAndSeekBasket.classList.add('hide-and-seek-basket--visible');
    this.initialContent = document.querySelector('.js-items-found-container').innerHTML;

    itemsToFindEls.forEach(element => {
      const { key } = element.dataset;
      element.addEventListener('click', () => {
        const { key } = element.dataset;
        this.setItemAsFound(key);
        element.classList.add(this.foundClass);
        const updatedFoundItemKeys = this.getFoundItems();
        this.updateHideAndSeekModal(updatedFoundItemKeys);
        this.updateBasket(updatedFoundItemKeys);
        if (updatedFoundItemKeys.length === this.itemsToFindKeys.length) {
          // this.hideAndSeekModal.classList.add('modal--active');
        } else {
          this.animateBasketCount();
          setTimeout(() => {
            this.stopAnimateBasketCount();
          }, 2500);
        }
      });
    });
    /*  console.log(localStorage); */
    const foundItemKeys = this.getFoundItems();
    this.hideFoundItems(foundItemKeys);
    this.updateHideAndSeekModal(foundItemKeys);
    this.updateBasket(foundItemKeys);

    // before 10/04/2023 hide modal, basket and eggs

    //Get date from settings
    const startDateString = new Date(theme.strings.hide_and_seek_start_date);
    const endDateString = new Date(theme.strings.hide_and_seek_end_date);

    console.log(startDateString);
    console.log(endDateString);

    const today = new Date();
    const startDate = startDateString;
    const easterDate = endDateString; 

    if (today >= startDate && today <= easterDate) {
      this.hideAndSeekBasket.classList.add('hide-and-seek-basket--visible');

      // show modal once, then set a cookie 
      if (!Cookies.get('hide-and-seek-modal')) {
        this.hideAndSeekModal.classList.add('modal--active');
        Cookies.set('hide-and-seek-modal', 'true', { expires: 1 });
      }
      
      itemsToFindEls.forEach(element => {
        element.classList.add('show');
      });
    }
  }

  discountCheck() {
    // For development only
    // eslint-disable-next-line no-console
    console.log(
      `If you get the error message "Uncaught (in promise) SyntaxError: Unexpected token < in JSON at position 0", it means you have to login in the admin. This dev check needs admin access to check if the discount if created there.`,
    );

    fetch(`/admin/discount_codes/lookup.json?code=${this.discountCode}`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Quick check if this discount code exists in Shopify
        // Check only possible when logged in the admin
        if (data.errors) {
          // eslint-disable-next-line no-console
          console.error('Warning: this discount doesnt exist in the admin yet!');
        }
        // eslint-disable-next-line no-console
        console.log(data);
      });
  }

  keyCheck(itemsToFindEls) {
    // For development only, check if there html hidden items with a wrong key on the current page
    itemsToFindEls.forEach(element => {
      const { key } = element.dataset;
      if (this.itemsToFindKeys.indexOf(key) === -1) {
        // eslint-disable-next-line no-console
        console.error(
          `WARNING, the key "${key}" is not in the itemsToFindKeys array of the Hide&Seek class! Therefore, people won't be able to complete the search.`,
          element,
          this.itemsToFindKeys,
        );
      }
    });
  }

  setItemAsFound(key) {
    localStorage.setItem(key, true);
  }

  getFoundItems() {
    const foundItems = [];
    this.itemsToFindKeys.forEach(key => {
      if (localStorage.getItem(key)) {
        foundItems.push(key);
      }
    });

    return foundItems;
  }

  hideFoundItems(foundItemsKeys) {
    const foundItemsOnPage = [];
    foundItemsKeys.forEach(itemKey => {
      const matchingEl = document.querySelector(
        `${this.itemsToFindElSelector}[data-key="${itemKey}"]`,
      );
      if (matchingEl) {
        matchingEl.classList.add('hide');
        foundItemsOnPage.push(matchingEl);
      }
    });
  }

  showAllItems() {
    this.itemsToFindKeys.forEach(itemKey => {
      const matchingEl = document.querySelector(
        `${this.itemsToFindElSelector}[data-key="${itemKey}"]`,
      );
      if (matchingEl) {
        matchingEl.classList.remove('hide');
        matchingEl.classList.remove(this.foundClass);
      }
    });
  }

  updateHideAndSeekModal(foundItems) {
    const foundContainer = document.querySelector('.js-items-found-container');
    const completedContainer = document.querySelector('.js-items-completed-container');
    const totalFoundString = theme.strings.hide_and_seek_found_items
      .replace('[item_count]', foundItems.length)
      .replace('[item_total]', this.itemsToFindKeys.length);
    let innerContent = '';

    if (foundItems.length) {
      if (foundItems.length === this.itemsToFindKeys.length) {
        //hide foundContainer
        foundContainer.classList.add('hide');
        innerContent = ``;
        //show completedContainer
        completedContainer.classList.remove('hide');
      } else {
        innerContent = `
        <p>${totalFoundString}</p>`;
      }
    } else {
      innerContent = `
        <p>${theme.strings.hide_and_seek_no_items_found}</p>`;
    }

    foundContainer.innerHTML = innerContent;
  }

  updateBasket(foundItems) {
    this.hideAndSeekBasketCountEl.innerHTML = foundItems.length;
    this.hideAndSeekBasketTotalEl.innerHTML = this.itemsToFindKeys.length;
    if (foundItems.length === this.itemsToFindKeys.length) {
      this.hideAndSeekBasketCompletedEl.classList.remove('hide');
      this.hideAndSeekBasketItemsCountEl.classList.add('hide');
    } else {
      this.hideAndSeekBasketCompletedEl.classList.add('hide');
      this.hideAndSeekBasketItemsCountEl.classList.remove('hide');
    }
  }

  animateBasketCount() {
    this.hideAndSeekBasketItemsCountEl.classList.add('hide-and-seek-basket__items-count--animate');
  }

  stopAnimateBasketCount() {
    this.hideAndSeekBasketItemsCountEl.classList.remove(
      'hide-and-seek-basket__items-count--animate',
    );
  }

  devChecks(itemsToFindEls) {
    this.discountCheck();
    this.keyCheck(itemsToFindEls);
  }
}
